import {AppInsightsAdapter} from '@hconnect/common/logging'

import {initializeMocks} from './api/mocking'
import {hideErrorOverlay} from './hideErrorOverlay'
import {initLocalization} from './localization'

export const initializeApp = async () => {
  // Start i18n init and telemetry concurrently; telemetry does not depend on localization.
  const localizationReady = initLocalization()
  AppInsightsAdapter.init()
  AppInsightsAdapter.allowTracking()
  await localizationReady
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const isRunningCypress = typeof window.Cypress !== 'undefined'
  const isProduction = process.env.REACT_APP_STAGE === 'prod'

  if (isProduction || isRunningCypress) {
    hideErrorOverlay()
  } else {
    initializeMocks()
  }
}
